import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { initGA, trackPage } from "@/lib/analytics";
import client from "@/lib/glossyApi";
import { EDITION_OVERRIDE_KEY } from "@/lib/issue";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import Home from "@/pages/Home";
import ReadPage from "@/pages/ReadPage";
import ArticlePage from "@/pages/ArticlePage";
import Directory from "@/pages/Directory";
import MemberPage from "@/pages/MemberPage";
import MemberPreview from "@/pages/MemberPreview";
import Join from "@/pages/Join";
import Call from "@/pages/Call";
import NewsletterArchive from "@/pages/NewsletterArchive";
import Membership from "@/pages/Membership";
import Noticeboard from "@/pages/Noticeboard";
import MembersDesk from "@/pages/MembersDesk";
import PartnerOffers from "@/pages/PartnerOffers";
import About from "@/pages/About";
import Archive from "@/pages/Archive";
import ArchiveEdition from "@/pages/ArchiveEdition";
import Interviews from "@/pages/Interviews";
import CoverMembers from "@/pages/CoverMembers";
import Auth from "@/pages/Auth";
import StudioLogin from "@/pages/StudioLogin";
import Portal from "@/pages/Portal";
import ProfileSent from "@/pages/ProfileSent";
import Admin from "@/pages/Admin";
import MediaKit from "@/pages/MediaKit";
import Privacy from "@/pages/Privacy";
import Cookies from "@/pages/Cookies";
import Terms from "@/pages/Terms";
import MembershipTerms from "@/pages/MembershipTerms";
import Contact from "@/pages/Contact";

function RouteTracker() {
  const location = useLocation();
  useEffect(() => { initGA(); }, []);
  useEffect(() => { trackPage(location.pathname); }, [location.pathname]);
  useEffect(() => {
    client.get("/edition").then((r) => {
      const nv = r.data.override === null || r.data.override === undefined ? "" : String(r.data.override);
      const cur = localStorage.getItem(EDITION_OVERRIDE_KEY) ?? "";
      if (cur !== nv) { localStorage.setItem(EDITION_OVERRIDE_KEY, nv); window.location.reload(); }
    }).catch(() => {});
  }, []);
  return null;
}

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
        <RouteTracker />
        <Toaster position="bottom-right" toastOptions={{ style: { borderRadius: 0, fontFamily: "Work Sans" } }} />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/read" element={<ReadPage />} />
          <Route path="/the-edit" element={<ReadPage />} />
          <Route path="/newsroom" element={<ReadPage variant="newsroom" />} />
          <Route path="/interviews" element={<Interviews />} />
          <Route path="/cover-members" element={<CoverMembers />} />
          <Route path="/read/:slug" element={<ArticlePage />} />
          <Route path="/about" element={<About />} />
          <Route path="/archive" element={<Archive />} />
          <Route path="/archive/:key" element={<ArchiveEdition />} />
          <Route path="/directory" element={<Directory />} />
          <Route path="/noticeboard" element={<Noticeboard />} />
          <Route path="/partners" element={<PartnerOffers />} />
          <Route path="/members-desk" element={<MembersDesk />} />
          <Route path="/member/:id" element={<MemberPage />} />
          <Route path="/preview/:token" element={<MemberPreview />} />
          <Route path="/newsletters" element={<NewsletterArchive />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/membership-terms" element={<MembershipTerms />} />
          <Route path="/join" element={<Join />} />
          <Route path="/call" element={<Call />} />
          <Route path="/membership" element={<Membership />} />
          <Route path="/media-kit" element={<MediaKit />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={<Auth mode="login" />} />
          <Route path="/studio" element={<StudioLogin />} />
          <Route path="/register" element={<Auth mode="register" />} />
          <Route path="/portal" element={<Portal />} />
          <Route path="/portal/sent" element={<ProfileSent />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
